import { useEffect, useState } from "react";

// Counter started at 1801 on this date, increments by 3 per week.
const START_DATE = new Date("2026-02-11T00:00:00Z").getTime();
const START_COUNT = 1801;
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
const INCREMENT_PER_WEEK = 3;

const getCurrentCount = () => {
  const elapsed = Math.max(0, Date.now() - START_DATE);
  return START_COUNT + Math.floor(elapsed / WEEK_MS) * INCREMENT_PER_WEEK;
};

export const ConsentsCounter = ({ className = "" }) => {
  const target = getCurrentCount();
  const [count, setCount] = useState(Math.max(0, target - 120));

  useEffect(() => {
    const start = Math.max(0, target - 120);
    const duration = 1800;
    const startTime = performance.now();
    let raf;
    const tick = (t) => {
      const elapsed = t - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(start + (target - start) * eased));
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target]);

  return (
    <span className={className} data-testid="consents-counter">
      {count.toLocaleString()}
    </span>
  );
};

export default ConsentsCounter;
